export default {
    label_task:{
        en:"Couriers",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Courier",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Courier",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Courier",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_code:{
        en:"Code",
        bn:"প্রিফিক্স"
    },
    label_contact_person :{
        en:"Contact Person",
        bn:"কর্মচারী আইডি"
    },
}